
              const locales = {
                en: {
                      pattern: 'This field is invalid',
                      invalid: 'This field is invalid',
                      required: 'The field value is required',
                      number: 'The field value is not a number',
                      integer: 'The field value is not an integer number',
                      url: 'The field value is a invalid url',
                      email: 'The field value is not a email format',
                      ipv6: 'The field value is not a ipv6 format',
                      ipv4: 'The field value is not a ipv4 format',
                      idcard: 'The field value is not an idcard format',
                      qq: 'The field value is not a qq number format',
                      phone: 'The field value is not a phone number format',
                      money: 'The field value is not a currency format',
                      zh: 'The field value is not a chinese string',
                      date: 'The field value is not a valid date format',
                      zip: 'The field value is not a zip format',
                      len: 'The length or number of entries must be {{len}}',
                      min: 'The length or number of entries must be at least {{min}}',
                      minLength: 'The length or number of entries must be at least {{minLength}}',
                      minItems: 'The length or number of entries must be at least {{minItems}}',
                      maximum: 'The field value cannot be greater than {{maximum}}',
                      exclusiveMaximum: 'The field value must be less than {{exclusiveMaximum}}',
                      minimum: 'The field value cannot be less than {{minimum}}',
                      exclusiveMinimum:
                        'The field value must be greater than {{exclusiveMinimum}}',
                      max: 'The field length or number of entries must be at most {{max}}',
                      maxLength:
                        'The field length or number of entries must be at most {{maxLength}}',
                      maxItems:
                        'The field length or number of entries must be at most {{maxItems}}',
                      whitespace: 'This field value cannot be blank string.',
                      enum: 'The field value must be one of {{enum}}',

                      const: 'The field value must be equal to {{const}}',
                      multipleOf: 'The field value must be divisible by {{multipleOf}}',
                      maxProperties:
                        'The number of field properties cannot be greater than {{maxProperties}}',
                      minProperties:
                        'The number of field properties cannot be less than {{maxProperties}}',
                      uniqueItems: 'Array elements are not unique',
                }
              };
              if (window['$_ENV'] && window['$_ENV'].language) {
                const globalLang = window['$_ENV'].language;
                Object.assign(locales, {
                  [globalLang.locale]: globalLang['FORMILY_VALIDATION_LOCALE']
                });
              }
              export default locales;
              